/**
 * Component to Show Collection details
 *
 *
 * @author Masuma
 */

import React, { useEffect, useState, Fragment, useRef, useContext } from 'react';

import { Skeleton, Input, Typography, Select, Table, Button } from 'antd';

import { useReactToPrint } from 'react-to-print';

import { GlobalContext, useTranslation } from 'soxo-bootstrap-core';

import './collection-detail.scss';

import { Collections, CollectionDetails } from '../../../../models';

import Collection from '../../../../models/collections';

import { formatCurrency } from '../../../../utils/currency.utils';

import { Rupee } from 'soxo-bootstrap-core';
import moment from 'moment-timezone';

const { Title, Text } = Typography;

export default function CollectionDetailView({ match, ...props }) {
    // var param = Location.search();

    const { user, defaultBranch } = useContext(GlobalContext);

    const [record, setRecord] = useState({});

    const [items, setItems] = useState([]);

    const print = useRef();

    const [loader, setLoader] = useState(false);

    const { id } = match.params;

    const [receipt, setReceipt] = useState(0);

    // To Translate to another language
    const { t, i18n } = useTranslation();

    useEffect(() => {
        loadData();
    }, []);

    const handlePrint = useReactToPrint({
        content: () => print.current,
        bodyClass: 'hello',
    });

    // for getting currecncy

    let otherDetails = user.firm.f_otherdetails1;

    let currency = JSON.parse(otherDetails);
    let currencySymbol = currency.currency_symbol;

    function loadData() {
        setLoader(true);

        Collections.loadReceipt(id).then((result) => {
            setRecord(result);

            setItems(result.colldetails);

            setLoader(false);

            if (result.colldetails && result.colldetails.length) {
                let no = result.colldetails[0].cold_rctno;

                setReceipt(no);
            }

            // CollectionDetails.getReceiptItems(result.cold_tranno).then((result) => {

            //     console.log(result);

            //     setRecord(result);
            //     setItems(result.colldetails)
            // });
        });
    }
    return (
        <div className="page-content">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div>
                    <Title level={3}>{t('Receipt')}</Title>
                    <p>{t('Receipt with Collection Details')}</p>
                </div>
                <Button type="dashed" className="print-button" onClick={handlePrint}>
                    {t('Print Invoice')}
                </Button>
            </div>
            <Fragment>
                <div className="card card-shadow receipt-preview">
                    {loader ? (
                        <Skeleton />
                    ) : (
                        <div className="card">
                            <div className="bill-header">
                                {/* <div>
        <img className="brand-logo" src={logo} alt="Logo" />
        <br />
        <h2>Receipt No: {record.cold_rctno}</h2>
    </div>
    <div>
        <p>376, 100 Feet Rd,</p>
        <p>Indiranagar, HAL 2nd Stage,</p>
        <p>Bengaluru, Karnataka 560038</p>
    </div> */}
                                <Title level={4}>{t('Credit Bill Collection Receipt')}</Title>
                            </div>
                            <hr />
                            <div className="bill-details">
                                <div className="information">
                                    <table>
                                        <tr>
                                            <td>
                                                <strong>{t('Receipt No.')}</strong>
                                            </td>
                                            <td>: {receipt}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>{t('OP No.')}</strong>
                                            </td>
                                            <td>: {record.opb_opno}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>{t('Name')}</strong>
                                            </td>
                                            <td>: {record.opb_name}</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <strong>{t('Order No.')}</strong>
                                            </td>
                                            <td>: {record.opb_bno}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div>
                                    <table>
                                        <tr>
                                            <td>
                                                <strong>{t('Date')}</strong>
                                            </td>
                                            <td>: {moment(record.opb_dt).format('DD/MM/YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>{t('Ip No.')}</strong>
                                            </td>
                                            <td>: {record.opb_ipno}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>{t('Department')}</strong>
                                            </td>
                                            <td>: {record.opb_deptmode}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <Table
                                className="bill-summary"
                                scroll={{ x: true }}
                                // rowKey={(record) => record.da_id}
                                dataSource={items}
                                columns={recieptColumns}
                                pagination={false}
                                summary={(pageData) => {
                                    let Total = 0;
                                    pageData.forEach((entry) => {
                                        Total += entry.cold_amt;
                                    });
                                    return (
                                        <>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell>
                                                    <strong>{t('Total')}</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>

                                                <Table.Summary.Cell>
                                                    <Text>
                                                        {/* <Rupee value={record.opb_amt + record.opb_disamt}></Rupee> */}
                                                        {formatCurrency(record.opb_amt + record.opb_disamt, currencySymbol)}
                                                    </Text>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell>
                                                    <strong>{t('Discount')}</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>

                                                <Table.Summary.Cell>
                                                    <Text>
                                                        {/* <Rupee value={record.opb_disamt}></Rupee> */}
                                                        {formatCurrency(record.opb_disamt, currencySymbol)}
                                                    </Text>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell>
                                                    <strong>{t('Net Amount')}</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>

                                                <Table.Summary.Cell>
                                                    <Text>
                                                        {/* <Rupee value={record.opb_netamt}></Rupee> */}
                                                        {formatCurrency(record.opb_netamt, currencySymbol)}
                                                    </Text>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell>
                                                    <strong>{t('Paid Amount')}</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>

                                                <Table.Summary.Cell>
                                                    <Text>
                                                        {/* <Rupee value={record.opb_paidamt}></Rupee> */}
                                                        {formatCurrency(record.opb_paidamt, currencySymbol)}
                                                    </Text>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell>
                                                    <strong>{t('Balance to Pay')}</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell></Table.Summary.Cell>

                                                <Table.Summary.Cell>
                                                    <Text>
                                                        {/* <Rupee value={record.opb_netamt - record.opb_paidamt}></Rupee> */}
                                                        {formatCurrency(record.opb_netamt - record.opb_paidamt, currencySymbol)}
                                                    </Text>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                        </>
                                    );
                                }}
                            />
                            <div className="receipt-footer">
                                <div>
                                    <p>{t('Created On:')}</p>
                                    <p>{t('Printed On:')}</p>
                                </div>
                                <p>{t('Signature')}</p>
                            </div>
                            {/* Print Block */}
                            <div className="print-block">
                                <WrapperClass ref={print}>
                                    <div className="card card-shadow bill-preview">
                                        <Fragment>
                                            <div className="page-content">
                                                <div className="card">
                                                    <Title level={4}>{t('Credit Bill Collection Receipt')}</Title>
                                                    <hr />
                                                    <div className="bill-details">
                                                        <table>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Receipt No.')}</strong>
                                                                </td>
                                                                <td>: {record.opb_gender}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('OP No.')}</strong>
                                                                </td>
                                                                <td>: {record.opb_opno}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Name')}</strong>
                                                                </td>
                                                                <td>: {record.opb_name}</td>
                                                            </tr>

                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Order No.')}</strong>
                                                                </td>
                                                                <td>: {record.opb_bno}</td>
                                                            </tr>
                                                        </table>
                                                        <table>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Date')}</strong>
                                                                </td>
                                                                <td>: {record.opb_opno}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Ip No.')}</strong>
                                                                </td>
                                                                <td>: {record.opb_ipno}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Department')}</strong>
                                                                </td>
                                                                <td>: {record.opb_deptmode}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <strong>{t('Date')}</strong>
                                                                </td>
                                                                <td>: {record.opb_dt}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <Table
                                                        className="bill-summary"
                                                        scroll={{ x: true }}
                                                        // rowKey={(record) => record.da_id}
                                                        dataSource={items}
                                                        columns={recieptColumns}
                                                        pagination={false}
                                                        summary={(pageData) => {
                                                            let Total = 0;
                                                            pageData.forEach((entry) => {
                                                                Total += entry.cold_amt;
                                                            });
                                                            return (
                                                                <>
                                                                    <Table.Summary.Row>
                                                                        <Table.Summary.Cell>
                                                                            <strong>{t('Total')}</strong>
                                                                        </Table.Summary.Cell>
                                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                                        <Table.Summary.Cell>
                                                                            <Text>
                                                                                {/* <Rupee value={record.opb_amt + record.opb_disamt}></Rupee> */}
                                                                                {formatCurrency(record.opb_amt + record.opb_disamt, currencySymbol)}
                                                                            </Text>
                                                                        </Table.Summary.Cell>
                                                                    </Table.Summary.Row>
                                                                    <Table.Summary.Row>
                                                                        <Table.Summary.Cell>
                                                                            <strong>{t('Discount')}</strong>
                                                                        </Table.Summary.Cell>
                                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                                        <Table.Summary.Cell>
                                                                            <Text>
                                                                                {/* <Rupee value={record.opb_disamt}></Rupee> */}
                                                                                {formatCurrency(record.opb_disamt, currencySymbol)}
                                                                            </Text>
                                                                        </Table.Summary.Cell>
                                                                    </Table.Summary.Row>
                                                                    <Table.Summary.Row>
                                                                        <Table.Summary.Cell>
                                                                            <strong>{t('Net Amount')}</strong>
                                                                        </Table.Summary.Cell>
                                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                                        <Table.Summary.Cell>
                                                                            <Text>
                                                                                {/* <Rupee value={record.opb_netamt}></Rupee> */}
                                                                                {formatCurrency(record.opb_netamt, currencySymbol)}
                                                                            </Text>
                                                                        </Table.Summary.Cell>
                                                                    </Table.Summary.Row>
                                                                    <Table.Summary.Row>
                                                                        <Table.Summary.Cell>
                                                                            <strong>{t('Paid Amount')}</strong>
                                                                        </Table.Summary.Cell>
                                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                                        <Table.Summary.Cell>
                                                                            <Text>
                                                                                {/* <Rupee value={Total}></Rupee> */}
                                                                                {formatCurrency(Total, currencySymbol)}
                                                                            </Text>
                                                                        </Table.Summary.Cell>
                                                                    </Table.Summary.Row>
                                                                    <Table.Summary.Row>
                                                                        <Table.Summary.Cell>
                                                                            <strong>{t('Balance to Pay')}</strong>
                                                                        </Table.Summary.Cell>
                                                                        <Table.Summary.Cell></Table.Summary.Cell>
                                                                        <Table.Summary.Cell>
                                                                            <Text>
                                                                                {/* <Rupee value={record.opb_netamt - Total}></Rupee> */}
                                                                                {formatCurrency(record.opb_netamt - Total, currencySymbol)}
                                                                            </Text>
                                                                        </Table.Summary.Cell>
                                                                    </Table.Summary.Row>
                                                                </>
                                                            );
                                                        }}
                                                    />
                                                    <div className="receipt-footer">
                                                        <div>
                                                            <p>{t('Created On:')}</p>
                                                            <p>{t('Printed On:')}</p>
                                                        </div>
                                                        <p>{t('Signature')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    </div>
                                </WrapperClass>
                            </div>
                            {/* Print Block ends */}
                        </div>
                    )}
                </div>
            </Fragment>
        </div>
    );
}

class WrapperClass extends React.Component {
    render() {
        return <div style={{ width: '100%' }}>{this.props.children}</div>;
    }
}

const recieptColumns = [
    {
        title: '#',
        width: '10',
        dataIndex: 'index',
        render: (value, item, index) => index + 1,
    },
    {
        title: 'Particulars',

        render: (items) => {
            return <div>{items.cold_paymentmode}</div>;
        },
        key: 'Particulars',
    },

    {
        title: 'Amount',
        width: '30',
        align: 'Right',
        render: (items) => {
            return <div>{items.cold_amt}</div>;
        },
        key: 'Amount',
    },
];
